module.exports = __webpack_public_path__ + "img/Levante.d3288800.png";